import * as angular from 'angular';
import { Decimal } from 'decimal.js';
import { config, reactShell } from '../../angular/utils/config';
import { AuthService } from '../_services/auth.service';
import { CreditLimitResource } from 'app/_resources/credit-limit.resource';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { UtilService } from 'app/_services/util.service';

class ShippersDetailsCreditLimitsComponentCtrl implements ng.IController {
    public creditLimits: CreditLimitDto[];
    public newCreditLimit: CreditLimitDto = null;
    public assignment: TsoShipperAssignmentsDto;
    public loading: boolean = false;
    public errorLoading: boolean = false;
    public isSso: boolean;

    public uiShowSuccessfullySavedForIdentifier: string = null;
    public uiShowSuccessfullyDeletedForIdentifier: string = null;
    private uiErrorMessage: string = null;
    public conmaSubscription = false;

    async $onInit() {
        if (config.contractManagement) {
            try {
                const response = await reactShell.axios.request({
                    url: config.contractManagement
                });
                this.conmaSubscription = Boolean(
                    response.data &&
                    response.data._links &&
                    response.data._links.shipper
                );
            } catch (err) {
                // just swallow any error - as of now this is only relevant to TAG and they _know_
                // they should not delete credit limits (we don't want to confuse other users in case of an error)
            }
        }

        this.loadCreditLimits();
        this.authService.userLoginPromise.promise.then(
            (res) => (this.isSso = res.role === 'SSO_ADMIN')
        );
    }
    constructor(
        private creditLimitResource: CreditLimitResource,
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private utilService: UtilService,
        private $timeout: ng.ITimeoutService,
        private authService: AuthService,
        private $location: ng.ILocationService
    ) {}

    public onCreditLimitSaved(
        savedCreditLimit: CreditLimitDto,
        isNew: boolean
    ) {
        this.clearMessages();
        this.uiShowSuccessfullySavedForIdentifier = savedCreditLimit.identifier;
        if (isNew) {
            this.creditLimits.splice(0, 0, savedCreditLimit);
            this.newCreditLimit = null;
        }
        this.utilService.scrollToAnchor('top');
        this.$timeout(() => {
            this.clearMessages();
        }, 10000);
    }

    public onCreditLimitDeleted(deletedCreditLimit: CreditLimitDto) {
        this.clearMessages();
        this.uiShowSuccessfullyDeletedForIdentifier =
            deletedCreditLimit.identifier;
        this.creditLimits = this.creditLimits.filter(
            (creditLimit) => creditLimit.id !== deletedCreditLimit.id
        );
        this.utilService.scrollToAnchor('top');
        this.$timeout(() => {
            this.clearMessages();
        }, 10000);
    }

    public onErrorWhileSavingOrDeleting(message: string) {
        this.clearMessages();
        this.uiErrorMessage = message;
        this.utilService.scrollToAnchor('top');
        this.$timeout(() => {
            this.clearMessages();
        }, 10000);
    }

    private clearMessages() {
        this.uiShowSuccessfullySavedForIdentifier = null;
        this.uiShowSuccessfullyDeletedForIdentifier = null;
        this.uiErrorMessage = null;
    }

    public loadCreditLimits() {
        let params = {
            shipperRefId: this.assignment.shipperRefId
        };

        this.loading = true;
        this.creditLimitResource
            .getCreditLimits(
                params,
                (res) => {
                    this.creditLimits = res;
                    let scrollTo = this.$location.search().scrollTo;
                    if (scrollTo) {
                        setTimeout(() => {
                            window.parent.scrollTo({
                                top: document
                                    .getElementById('creditlimit' + scrollTo)
                                    .getBoundingClientRect().top,
                                behavior: 'smooth'
                            });
                        }, 100);
                    }
                },
                (err: any) => (this.errorLoading = true)
            )
            .$promise.finally(() => (this.loading = false));
    }

    public addNewCreditLimit() {
        this.clearMessages();
        this.TransmissionSystemOperator.get(
            { id: this.assignment.tsoRefId },
            (res: TsoDto) => {
                this.newCreditLimit = {
                    id: null,
                    identifier: null,
                    interval: this.utilService.getRunTimeSuggestion('MONTH'),
                    staticLimit: {
                        amount: {
                            value: new Decimal('0'),
                            floatingPointNumber: true
                        },
                        currency: res.currency
                    },
                    usedLimit: {
                        amount: {
                            value: new Decimal('0'),
                            floatingPointNumber: true
                        },
                        currency: res.currency
                    },
                    creditFramework: null,
                    shipperRefId: this.assignment.shipperRefId,
                    tsoRefId: null
                };
            }
        );
    }
}

angular.module('app').component('pkpShippersDetailsCreditLimits', {
    controller: ShippersDetailsCreditLimitsComponentCtrl,
    template: require('app/shippers/shippers-details-credit-limits.component.html'),
    bindings: {
        assignment: '<'
    }
});
